import React from 'react'
import log from 'loglevel'
import { Risk } from '@trustero/trustero-api-web/lib/risk/risk_pb'
import { EditableMarkupOnClick } from 'src/components/Reusable/Inputs'
import { useCanPerformAction } from 'src/app/AppAuth/AppAuth.hooks'
import { CAPABILITY } from '@trustero/trustero-api-web/lib/authz/permissions_pb'
import { Markup } from 'src/components/Reusable/Text/Markup'
import { useCreateOrUpdateRisks } from '../risks.hooks'

export const RisksNotes = ({ risk }: { risk: Risk }): JSX.Element => {
  const updateRisk = useCreateOrUpdateRisks()

  const id = risk.getId()
  const note = risk.getNotes()
  const riskObj = risk instanceof Risk ? risk.toObject() : undefined
  const canUpdateRisk = useCanPerformAction<Risk.AsObject>(
    CAPABILITY.CAN_UPDATE_RISKS,
    riskObj,
  )

  const onSave = async (newNote: string) => {
    try {
      if (note === newNote || !risk) {
        return
      }
      risk.setNotes(newNote)
      await updateRisk([risk])
    } catch (err) {
      log.error(`Failed to update note for riskId: ${id}`, err)
    }
  }

  return (
    <EditableMarkupOnClick
      initialValue={note}
      onSave={onSave}
      isDisabled={!canUpdateRisk}
    >
      {note.length ? <Markup markdown={note} /> : <p>None</p>}
    </EditableMarkupOnClick>
  )
}
